import React, { useState, useContext } from 'react';
import Logo from '../assets/logo.png'; 
import '../styles/register.css';

import * as Constants from '../constants';
import { ShareContext } from '../context/ShareContext'
import { Link, useNavigate } from 'react-router-dom';
import BackLoader from '../components/backloader'
import DynamicIcon from '../components/dynamicicon';
import JisButton from '../components/controls/jisButton';
import JisCheckbox from '../components/controls/jisCheckbox';

function Login() {
    const [staySigned, setStaySigned] = useState(false)
    const navigate = useNavigate();
    const { profile , setProfile, setToken,setFrequentData,setCheckingToken, setIsExpired} = useContext(ShareContext);
    const [seePass, setSeePass] = useState(false);
    const [err, setErr] = useState('');
    const [loading, setLoading] =useState(false);
    const [email, setEmail]=useState('');
    const [password, setPassword] = useState('');
    const [login, setLogin]= useState({username:'',password:''});
  const [flowerror, setFlowError]=useState('');
  const [isPass, setIsPass]=useState(true);
  const [remember, setRemember] = useState(false);

     const onLoginChange = (e) => {
    setLogin({...login, [e.target.name]: e.target.value})
}

const onBack=()=>{
  navigate('/');
}
    const onLogin=async(e)=>{
        e.preventDefault(); 
        setErr('');
          setLoading(true);
          
          try {
            var v={...login};
            const resp = await fetch(`${Constants.apiUrl}/profile/login`, {
              method: 'POST',
              body:JSON.stringify(v) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                //setGazettes(data.gazettes);
                
                setToken(data.token);
                localStorage.setItem("token",data.token);

                var ids={...data.res, role:data.role};
              
                setProfile(ids);
                localStorage.setItem("profile", JSON.stringify(ids))
                localStorage.setItem("freqdata", JSON.stringify(data.freq));
                setFrequentData(data.freq);
                setIsExpired(false);
                navigate('/dashboard');
                setCheckingToken(false);
            }else {   
              setErr('username/password not correct');
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
           // onMove();
          }
  
         }

  return (
    <div class='reg_container'>
      <BackLoader open={loading} />  
    <div class="homeside">
        <div style={{flex:1}}>
             <img src={Logo} alt="JIS Logo" className='logo' style={{width:100}}/> 
        </div>
      
       
                <div className="boxx">
                    
                    <p className="text"><div>1. </div> <div> You can register as a Legal Counsel, Non-legal Counsel and also do E-Affidavit.</div></p>
                    <p className="text"> <div>2.</div><div className='dtext'>For Individual and Organisation registration you need a Payer ID.</div> </p>
                    <p className="text"><div>3. </div><div className='dtext'>If you have a Payer ID select the option "I have a Payer ID</div> </p>
                    <p className="text"><div>4. </div><div className='dtext'>If you do not have a Payer ID select the option "I do not have a Payer ID</div> </p>
                    <p className="text"><div>5. </div><div className='dtext'>If you do not have a Payer ID you can generate the Payer ID during the registration process.
                     It is mandatory  to enter the NIN when the fields are displayed.</div> </p>
                    <p className="text"> <div>6.</div><div className='dtext'> Once you are done with the last step, click the "Submit" button
                     to complete the registration process.</div></p>
                </div>
</div>

    <main class="contentside">
<div className='form-center'>
            <div className='form-box'>
               <div>
                <div className="boo" onClick={onBack}>
                        <DynamicIcon size={16} iname="chevron-left" />
                        <a className="back">Back</a>
                    </div>
      <div  className='content-title'>Login to your account</div>
               </div>
               <form onSubmit={onLogin}>
        <div  className="input-group">
            <label> Username</label>
            <div className='input-wrapper'>
               
                <input  placeholder='Username' required={true} name="username" value={login.username} onChange={onLoginChange}   />
            </div>
        </div>
        <div  className="input-group">
            <label> Password</label>
            <div className='input-wrapper'>
               
                <input  placeholder='Enter Password' required={true} type={`${isPass?'password':'text'}`} name="password" value={login.password} onChange={onLoginChange}   />
                <DynamicIcon iname={`${isPass?'eye':'eye-off'}`} onClick={()=> setIsPass(!isPass)} />
            </div>
        </div>

        <div class="options" style={{marginBottom:16, marginTop:16}}>
         
      
          <Link className='forgot-password' to="/forgetpassword">Forgot Password?</Link>
        </div>
{err!="" && <div className='error'>{err}</div>}
        <div style={{display:'flex', flexDirection:'column'}}>
             <JisButton type='submit' loading={loading}>Login</JisButton>
             <div style={{textAlign:'center',margin:20}}>
               New to Lagos State Judiciary? <Link className='special-link' to="/register">Sign Up</Link>
             </div>   
        </div>
           

      </form>
            </div>
      </div>
     
      
    </main>
  {loading &&  <BackLoader />}  
  </div>
  )
}

export default Login